/* CO2Art — the local-store bar (sections/local-store-bar.liquid), 2026-09-11. Plan: co2art-ai docs/plans/2026-09-11-eu-theme-geo-bar-KICKOFF.md.
   Runs on www.co2art.eu only, on browsing pages, for a real visitor with no decision yet: one first-party fetch of
   /browsing_context_suggestions.json (Shopify's own country), the rule for that country from the section's JSON, the bar.
   Yes = cookie co2art_local_store=<host> and the mirror with the current path; a later visit leaves before paint (layout/theme.liquid).
   No / Esc = co2art_local_store=stay. A language pick on www (the header menu's links, the footer / drawer selects) clears the cookie.
   The country is kept in sessionStorage, so a visitor who ignores the bar costs one fetch per tab, not one per page; a visitor who
   arrived FROM a mirror (referrer) chose English on purpose — no bar this session. A theme preview never shows the bar (Shopify.theme.role
   is not 'main' on an unpublished copy; the ?preview_theme_id parameter itself is stripped by Shopify's own redirect, so it cannot be the
   guard) unless ?geo_bar=on was seen in the tab — the switch for a proof or a look at a copy. Concept swaps the DOM on page transitions
   and re-executes injected scripts: the custom element upgrades on every page, the define is guarded.
   2026-09-11 (performance plan T1): the bar is a fixed overlay over the announcement band — hidden = display none, is-open = slid in
   (a 0.3 s transform in the section's <style>); open() / close() toggle both, so nothing in the page's flow ever moves. */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('local-store-bar')) return;

  /* 2026-09-21 (co2art-ai docs/plans/2026-09-21-us-theme-port-PLAN.md): the home host is the Store profile's, printed by the section
     as data-home — one code base serves co2art.eu and co2art.us; the literal is only the fallback for a section rendered without it. */
  var HOME = (function () { try { var el = document.querySelector('local-store-bar[data-home]'); return (el && el.getAttribute('data-home')) || 'www.co2art.eu'; } catch (e) { return 'www.co2art.eu'; } })();
  var NAME = 'co2art_local_store';
  var SKEY = 'co2art_local_store_country';
  var FKEY = 'co2art_local_store_force';
  var BROWSE = /^\/(?:$|collections|products|pages|blogs|search)/;
  /* CO2Art 2026-09-17 (Karol: "kazdy user przychodzacy z US zostanie automatycznie redirected na co2art.us"): the US rule
     (kind "store") no longer asks — the visitor leaves for the US shop at once. Crawlers never do: Google renders and crawls
     co2art.eu mostly from US IPs, and a blanket redirect would hand our European pages to the US shop in the index.
     2026-09-22 (Karol: "informować usera przez bar … czy chce być przekierowany"; co2art-ai docs/plans/2026-09-22-us-geo-bar-ask-not-redirect.md):
     that is the EU shop's choice, not the code's — the Store profile's store_geo_store_rule (printed as data-store-rule) says
     "redirect" on co2art.eu and "ask" on co2art.us, where a European visitor sees the bar and leaves only on Yes (the port's D4). */
  /* ONE crawler pattern, byte-identical in layout/theme.liquid's pre-paint script (2026-09-23, EU audit E4-01 / US GAP-G2-02:
     GoogleOther, Mediapartners-Google, facebookcatalog and Perplexity-User were redirected to the other store) */
  var BOT = /bot|crawler|spider|crawling|slurp|bingpreview|facebookexternalhit|facebookcatalog|embedly|quora|pinterest|whatsapp|telegram|lighthouse|pagespeed|gtmetrix|ahrefs|semrush|screaming frog|headlesschrome|chrome-lighthouse|google-|googleother|mediapartners|apis-google|feedfetcher|perplexity|-user\b|duckduck|yandex|baidu|applebot|petalbot|linkedinbot|twitterbot|discordbot|slackbot/i;
  function isBot() { try { return BOT.test(navigator.userAgent || ''); } catch (e) { return true; } }
  /* the other shop is a separate shop: 26 of our 31 published product handles exist on co2art.us (29 on co2art.us, 26 shared —
     measured 2026-09-17 / 2026-09-21), the collection handles differ. So a product page keeps its path and everything else lands
     on the other shop's home page — both directions. */
  function storeTarget(host) {
    var p = location.pathname;
    return 'https://' + host + (/^\/products\//.test(p) ? p + location.search + location.hash : '/');
  }

  function readCookie() {
    var m = document.cookie.match(/(?:^|; )co2art_local_store=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function writeCookie(value, days) {
    document.cookie = NAME + '=' + encodeURIComponent(value) + '; max-age=' + (days * 86400) + '; path=/; SameSite=Lax; Secure';
  }
  function clearCookie() {
    document.cookie = NAME + '=; max-age=0; path=/; SameSite=Lax; Secure';
  }
  /* 2026-09-22 (Karol's ack, co2art-ai docs/plans/2026-09-22-eu-hop-keeps-click-identity-PLAN.md): a MARKET hop made by script keeps
     the visitor's Google identity. gtag's cross-domain linker decorates anchor clicks and form submits, never a location.replace(), so a
     paid click that opened a product before answering this bar reached the market domain as a NEW GA4 user with referrer www.co2art.eu —
     GA4 "co2art.eu / referral", our books "Direct" (#EU24421, reproduced in docs/research/2026-09-22-eu-paid-click-hop/). A hidden link
     gets the linker's own trigger (mousedown) and its href is read back, so the linker's domain list and consent state decide: without
     consent there is no gtag and the URL comes back unchanged. Never for the other shop (another GA4 property, another Ads account). */
  function withLinker(url) {
    try {
      var a = document.createElement('a');
      a.href = url; a.hidden = true; a.tabIndex = -1; a.setAttribute('aria-hidden', 'true');
      (document.body || document.documentElement).appendChild(a);
      a.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, button: 0 }));
      var out = a.href;
      a.remove();
      return out || url;
    } catch (e) { return url; }
  }
  /* 2026-09-22 (Karol: "na .eu dostaję dwa razy zapytanie o akceptację cookies"; co2art-ai docs/plans/2026-09-22-cookie-banner-after-geo-bar.md):
     one question at a time — the bar publishes where it stands (window.co2artGeo + a 'co2art:geo' event) and the cookie banner
     (assets/cookie-banner.js) waits while it is 'pending' or 'offer': a Yes leaves ('leaving') and the market domain asks once, in the
     visitor's language; a No ('closed') or no offer ('none') lets the banner show here. From the second page the bar is shown on in a tab,
     the offer no longer holds the banner back ('none'), so a visitor who ignores the bar is still asked. */
  function geo(state) {
    window.co2artGeo = state;
    try { document.dispatchEvent(new CustomEvent('co2art:geo', { detail: { state: state } })); } catch (e) { /* old browsers: the banner's 3-s cap */ }
  }
  function sessionGet() { try { return sessionStorage.getItem(SKEY); } catch (e) { return null; } }
  function sessionSet(v) { try { sessionStorage.setItem(SKEY, v); } catch (e) { /* private mode: one fetch per page instead */ } }
  function isLive() { return !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main'); }
  function forced() { try { return sessionStorage.getItem(FKEY) === '1'; } catch (e) { return false; } }
  function force(on) { try { if (on) sessionStorage.setItem(FKEY, '1'); else sessionStorage.removeItem(FKEY); } catch (e) { /* nothing */ } }
  function whenVisible(fn) {
    if (document.visibilityState !== 'hidden') return fn();
    document.addEventListener('visibilitychange', function once() {
      if (document.visibilityState !== 'hidden') { document.removeEventListener('visibilitychange', once); fn(); }
    });
  }
  function fill(tpl, rule) {
    return String(tpl || '')
      .replace(/\[country\]/g, rule.country)
      .replace(/\[language\]/g, rule.language || '')
      .replace(/\[currency\]/g, rule.currency || '')
      .replace(/\[store\]/g, rule.host.replace(/^www\./, ''));
  }
  function readRules(root) {
    try { return JSON.parse(root.querySelector('script[data-rules]').textContent); } catch (e) { return null; }
  }
  function ruleForHost(rules, host) {
    for (var k in rules) if (rules[k].host === host) return rules[k];
    return null;
  }

  class LocalStoreBar extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-design-mode')) { this.hidden = false; this.classList.add('is-open'); return; }
      if (location.hostname !== HOME || navigator.webdriver || !window.fetch) return;
      var q = location.search;
      if (/[?&]no_geo=1/.test(q)) { clearCookie(); force(false); return; }
      if (/[?&]geo_bar=on/.test(q)) force(true);
      if (!isLive() && !forced()) return;
      if (!BROWSE.test(location.pathname)) return;
      if (readCookie()) return;
      this.rules = readRules(this);
      if (!this.rules) return;
      var ref = '';
      try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) { ref = ''; }
      /* arrived from one of our own domains (the US shop included) — a deliberate return: never ask, never bounce back */
      if (ref && ref !== HOME && ruleForHost(this.rules, ref)) {
        sessionSet('none');
        writeCookie('stay', parseInt(this.dataset.days, 10) || 365);
        return;
      }
      var self = this;
      geo('pending');
      whenVisible(function () { self.detect(); });
    }

    detect() {
      var self = this, cached = sessionGet();
      if (cached) { if (cached !== 'none') self.offer(cached); else geo('none'); return; }
      fetch('/browsing_context_suggestions.json', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var code = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
          code = code ? String(code).toUpperCase() : '';
          if (!code || !self.rules[code]) { sessionSet('none'); geo('none'); return; }
          sessionSet(code);
          self.offer(code);
        })
        .catch(function () { sessionSet('none'); geo('none'); });
    }

    offer(code) {
      var rule = this.rules[code];
      if (!rule || rule.host === location.hostname) { geo('none'); return; }
      /* the other shop: where the profile says "redirect" (co2art.eu → US visitors, Karol 2026-09-17) leave at once — crawlers stay;
         where it says "ask" (co2art.us → European visitors, Karol 2026-09-22) fall through to the bar with the store sentence */
      var storeRule = rule.kind === 'store';
      /* a crawler never gets the other-shop rule at all — neither the redirect nor the bar (it indexes the page as a visitor with no offer) */
      if (storeRule && isBot()) { sessionSet('none'); geo('none'); return; }
      if (storeRule && this.dataset.storeRule !== 'ask') {
        geo('leaving');
        writeCookie(rule.host, parseInt(this.dataset.days, 10) || 365);
        location.replace(storeTarget(rule.host));
        return;
      }
      var text = this.querySelector('[data-text]');
      var go = this.querySelector('[data-action="go"]');
      var stay = this.querySelector('[data-action="stay"]');
      if (!text || !go || !stay) { geo('none'); return; }
      /* phones (≤ 767 px) get the one-line sentence, so the overlay stays over the announcement band and never reaches the header */
      var phone = !!(window.matchMedia && matchMedia('(max-width: 767px)').matches);
      /* the sentence: the language one where the rule has a language ("read this shop in Polish on co2art.pl?" — on co2art.us the
         mirror rules point at the EU market domains, Karol 2026-09-22), the store one where it has none ("shop in EUR on co2art.eu?") */
      var tpl = !rule.language
        ? ((phone && text.dataset.messageStoreMobile) || text.dataset.messageStore)
        : ((phone && text.dataset.messageMobile) || text.dataset.message);
      text.textContent = fill(tpl, rule);
      var self = this, days = parseInt(this.dataset.days, 10) || 365;
      go.addEventListener('click', function () {
        if (go.disabled) return;
        geo('leaving');
        writeCookie(rule.host, days);
        /* a store rule (the other shop): a product keeps its path, the rest lands on that shop's home; the cart carry is for the
           market domains of ONE shop (the head script skips it for a store host too) */
        if (storeRule) { location.replace(storeTarget(rule.host)); return; }
        var target = 'https://' + rule.host + location.pathname + location.search + location.hash;
        /* 2026-09-19 (push B, Karol's D4): the cart and the applied code travel along (assets/co2art.js reads /cart.js; at most 1.5 s) */
        var carry = window.co2artCarry;
        if (carry && typeof carry.url === 'function') { go.disabled = true; carry.url(target).then(function (u) { location.replace(withLinker(u)); }); }
        else location.replace(withLinker(target));
      });
      stay.addEventListener('click', function () { self.stay(days); });
      this._esc = function (ev) { if (ev.key === 'Escape' && !self.hidden) self.stay(days); };
      document.addEventListener('keydown', this._esc);
      this.open();
      /* the first page the bar opens on in this tab holds the cookie banner back; later pages do not (a visitor who ignores the bar is asked) */
      var seen = 0; try { seen = parseInt(sessionStorage.getItem('co2art_geo_offers') || '0', 10) + 1; sessionStorage.setItem('co2art_geo_offers', String(seen)); } catch (e) { seen = 1; }
      geo(seen > 1 ? 'none' : 'offer');
    }

    /* display first, the slide on the next frames — a class added in the same frame as display:none → block never transitions */
    open() {
      var self = this;
      this.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { self.classList.add('is-open'); }); });
    }

    /* slide out, then display none (the transition's end or 350 ms, whichever first; no motion = at once) */
    close() {
      var self = this, done = false;
      var finish = function () { if (done) return; done = true; self.hidden = true; };
      this.classList.remove('is-open');
      if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return finish();
      var timer = setTimeout(finish, 350);
      this.addEventListener('transitionend', function once(ev) {
        if (ev.target !== self) return;
        self.removeEventListener('transitionend', once); clearTimeout(timer); finish();
      });
    }

    stay(days) {
      writeCookie('stay', days);
      this.close();
      geo('closed');
      if (this._esc) { document.removeEventListener('keydown', this._esc); this._esc = null; }
    }

    disconnectedCallback() {
      if (this._esc) { document.removeEventListener('keydown', this._esc); this._esc = null; }
    }
  }
  customElements.define('local-store-bar', LocalStoreBar);

  /* A language pick on www is the visitor's word: the choice is cleared, so the next visit asks again or lands as picked. */
  if (location.hostname === HOME) {
    var rulesCache = null;
    function rules() {
      if (rulesCache === null) { var el = document.querySelector('local-store-bar'); rulesCache = (el && readRules(el)) || {}; }
      return rulesCache;
    }
    document.addEventListener('click', function (ev) {
      var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
      if (!a) return;
      var host;
      try { host = new URL(a.getAttribute('href'), location.href).hostname; } catch (e) { return; }
      if (host !== HOME && ruleForHost(rules(), host)) clearCookie();
    }, true);
    document.addEventListener('change', function (ev) {
      var s = ev.target;
      if (s && s.tagName === 'SELECT' && /doGTranslate/.test(s.getAttribute('onchange') || '')) clearCookie();
    }, true);
  }
})();
